/**
import CCheckbox from './checkbox.vue';
import CCheckboxgroup from './checkboxgroup.vue';
 * Created by david on 2017/6/1.
 */

import CTextbox from './textbox.vue';
import CSelect from './select.vue';
import CTabcontain from './tab/tabcontain.vue';
import CTabpage from './tab/tabpage.vue';
import CEcharts from './echarts.vue';
import CCheckbox from './checkbox.vue';
import CCheckboxgroup from './checkboxgroup.vue';
import Cdatepicker from './datepicker.vue';
import Ctextarea from './textarea.vue';
import Ctoggleswitch from './toggleswitch.vue';
import CThreecheckbox from './threecheckbox.vue';
import Cimageselect from './imageselect.vue';
import Caddressselect from './addressselect.vue';
import Crichtext from './richtext/richtext.vue'
export default {
    CTextbox,
    CSelect,
    CTabcontain,
    CTabpage,
    CEcharts,
    CCheckbox,
    CCheckboxgroup,
    Cdatepicker,
    Ctextarea,
    Ctoggleswitch,
    CThreecheckbox,
    Cimageselect,
    Caddressselect,
    Crichtext
};



// WEBPACK FOOTER //
// ./src/components/common/index.js